// An optional task's exercise ledger at window grain (K9c-1a): each row is
// one modification's exercise of the task for one as-exercised window. Two
// rows sharing a window are that window's tranches: the later ones are
// re-exercises of it. A line a later modification moved keeps the tranche's
// window and carries its own current end.
import { contractDateISO } from '../../../../lib/contractDate';
/** The first exercised first; an undated row last; then by id. */ function byExercised(a, b) {
    const da = contractDateISO(a.exercisedAt);
    const db = contractDateISO(b.exercisedAt);
    if (da !== db) {
        if (!da) return 1;
        if (!db) return -1;
        return da < db ? -1 : 1;
    }
    return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
/** The task's tranches by as-exercised window, each window's in exercised order. */ export function exerciseWindowTranches(exercises) {
    const out = new Map();
    for (const e of exercises){
        const start = contractDateISO(e.popStartDate);
        const end = contractDateISO(e.popEndDate);
        if (!start || !end) continue;
        const key = `${start}..${end}`;
        out.set(key, [
            ...out.get(key) ?? [],
            e
        ]);
    }
    for (const rows of out.values())rows.sort(byExercised);
    return out;
}
/** For each later tranche of a window: which tranche it re-exercises. */ export function reexerciseNotes(exercises) {
    const out = new Map();
    for (const [first, ...later] of exerciseWindowTranches(exercises).values()){
        for (const e of later){
            const on = contractDateISO(e.exercisedAt);
            out.set(e.id, {
                of: first,
                afterWindowEnded: !!on && on > contractDateISO(e.popEndDate)
            });
        }
    }
    return out;
}
/** The line's current end when a later modification moved it off the tranche's. */ export function lineNowEnds(tranche, line) {
    const now = contractDateISO(line.popEndDate);
    const asExercised = contractDateISO(tranche.popEndDate);
    return now && asExercised && now !== asExercised ? now : null;
}
